var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteHealthInsurance = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.759 3.03a.8.8 0 0 1 .429 0l9.85 2.739a.801.801 0 0 1 .58.661c.057.411 1.36 10.119-1.983 14.948-3.34 4.823-8.265 6.059-8.474 6.11a.805.805 0 0 1-.376 0c-.208-.051-5.134-1.287-8.473-6.11C2.968 16.548 4.272 6.84 4.329 6.43a.801.801 0 0 1 .579-.661zm1.67 6.97H13.57a.707.707 0 0 0-.71.71v2.15h-2.15a.707.707 0 0 0-.71.71v2.86c0 .396.315.71.71.71h2.15v2.15c0 .395.314.71.71.71h2.86a.62.62 0 0 0 .274-.057.724.724 0 0 0 .42-.508c.008-.049.017-.097.017-.146v-2.148h2.148c.396 0 .711-.315.711-.711v-2.86a.714.714 0 0 0-.719-.71h-2.14v-2.15a.707.707 0 0 0-.711-.71z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteHealthInsurance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-health-insurance.e7a1a8eb19533278fd55b7197586fdce.svg";